import { render, staticRenderFns } from "./SclAdd.vue?vue&type=template&id=544c0770&scoped=true"
import script from "./SclAdd.vue?vue&type=script&lang=js"
export * from "./SclAdd.vue?vue&type=script&lang=js"
import style0 from "./SclAdd.vue?vue&type=style&index=0&id=544c0770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c0770",
  null
  
)

export default component.exports